import makeApiRequest from './makeApiRequest'
import configServer from '../../configs/server'
import queryString from 'query-string'

const apiRequest = makeApiRequest()

export const generateLabel = (id) => {
    const data = {force: true}
    return apiRequest.post(`/barcode/${id}/label`, data)
}

export const updateBarcode = (id, data) => {
    return apiRequest.put(`/barcode/${id}`, data)
}

export const updateBarcodeReturnAddress = (id, data) => {
    return apiRequest.put(`/barcode/${id}/return-address`, data)
}

// export const markLabelled = (barcode) => {
//     return apiRequest.post(`/barcode/${barcode}/mark-labelled`)
// }

export const markLabelled = (barcode, data) => {
    return apiRequest({
        url: `/barcode/${barcode}/mark-labelled`,
        method: 'POST',
        data,
    })
}

export const deleteBarcode = (id) => {
    return apiRequest.delete(`/barcode/${id}`)
}

export const createListBarcode = (data) => {
    return apiRequest.post('/barcode/list', data)
}

export const importListBarcode = (data) => {
    return apiRequest.post('/barcode/list?source=import', data)
}

export const getListBarcode = (params) => {
    return apiRequest.post('/v3/barcode', params)
}

export const getListBarcodeV4 = (params) => {
    return apiRequest.post('/v4/barcode', params)
}

export const getListBarcodeV41 = (params) => {
    return apiRequest.post('/v4.1/barcode', params)
}

export const updateBarcodeProduct = (barcodeId, productId, data) => {
    return apiRequest.put(`/barcode/${barcodeId}/products/${productId}`, data)
}

export const getBarcodeByNumber = (barcodeNumber, params = '') => {
    var params_str = params !== '' ? '?' + params : ''
    return apiRequest.get(`/barcode/barcode_number/${barcodeNumber}${params_str}`)
}

export const getStatistics = () => {
    return apiRequest.get('/barcode/statistics')
}

export const getStatisticsV2 = () => {
    return apiRequest.get('/v2/barcode/statistics')
}

export const getStatisticsV3 = () => {
    return apiRequest.get('/v3/barcode/statistics')
}

export const getFilters = () => {
    return apiRequest.get('/barcode/filters')
}

export const getDesign3D = (data) => {
    const {maketplace, item_number} = data
    return apiRequest.get('/barcode/' + maketplace + '/item/' + item_number + '/designurl')
}

export const generateLabel3D = (id, pos) => {
    return apiRequest.post(`/barcode/${id}/label_item/${pos}`)
}

export const getParcel = (parcel_id) => {
    return apiRequest.get(`/parcel/${parcel_id}`)
}

export const createParcel = (data) => {
    return apiRequest.post('/parcel', data)
}

export const generateParcelLabel = (parcel_id) => {
    return apiRequest.post(`/parcel/${parcel_id}/label`)
}

export const resyncDesign = (id, pos, designKey) => {
    return apiRequest({
        url: `/barcode/${id}/label_item/${pos}/sync-design`,
        method: 'POST',
        data: {
            designKey,
        },
    })
}

export const exportCSV = (params) => {
    return apiRequest({
        url: `/barcode/export-csv`,
        method: 'GET',
        params,
    })
}

export const getBarcodeByArrayNumber = (params) => {
    return apiRequest({
        url: `/barcode/filter`,
        method: 'POST',
        data: params,
    })
}


export const exportShipping = (params) => {
    return apiRequest.get('/export/shipping', {params})
}

export const getExportOrdersCSV = (params) => {
    const baseUrl = configServer.url
    const query = queryString.stringify(params)

    return `${baseUrl}/exporter/v4/barcode/export-csv?${query}`
}

export const getExportOrdersCSVv4 = (params) => {
    const baseUrl = configServer.url
    const query = queryString.stringify(params)

    return `${baseUrl}/exporter/v4/barcode/export-csv?${query}`
}

export const getExportOrdersCSVv41 = (params) => {
    const baseUrl = configServer.url
    const query = queryString.stringify(params)

    return `${baseUrl}/exporter/v4.1/barcode/export-csv?${query}`
}

export const getExportLabel = (params) => {
    const baseUrl = configServer.url
    const query = queryString.stringify(params)

    return `${baseUrl}/exporter/export-labels?${query}`
}

export const getExportOrdersRoyalMail = (params) => {
    const baseUrl = configServer.url
    const query = queryString.stringify(params, {arrayFormat: 'bracket'})

    return `${baseUrl}/exporter/royal-mail-barcode/export-csv?${query}`
}

export const getExportOrdersSingaporePost = (params) => {
    const baseUrl = configServer.url
    const query = queryString.stringify(params, {arrayFormat: 'bracket'})

    return `${baseUrl}/exporter/singapore-post-barcode/export-csv?${query}`
}

export const getExportShippingOrdersCSV = (params) => {
    const baseUrl = configServer.barcodeUrl
    const query = queryString.stringify(params)

    return `${baseUrl}/export/shipping?${query}`
}

export const getExportShippingOrdersCSVv41 = (params) => {
    const baseUrl = configServer.barcodeUrl
    const query = queryString.stringify(params)

    return `${baseUrl}/v4.1/export/shipping?${query}`
}

export const getExportSku = (params) => {
    const baseUrl = configServer.barcodeUrl
    const query = queryString.stringify(params)

    return `${baseUrl}/skus/export/list-products?${query}`
}

export const getExportSkuV3 = (params) => {
    const baseUrl = configServer.barcodeUrl
    const query = typeof params !== 'string' ? queryString.stringify(params) : params

    return `${baseUrl}/v3/skus/export/list-products?${query}`
}

export const productionTimeStatistics = async (params) => {
    const query = typeof params !== 'string' ? queryString.stringify(params) : params

    return apiRequest({
        url: `/report/production-time-statistics?${query}`,
        method: 'GET',
    })
}

export const exportProductionTimeStatistics = (params) => {
    const baseUrl = configServer.barcodeUrl
    const query = queryString.stringify(params)

    return apiRequest({
        url: `/report/production-time-statistics/csv?${query}`,
        method: 'GET',
    }).then(response => {
        const {data} = response
        const {data: rows} = {...data}

        return rows || []
    })
}

export const markWrongDesign = (barcodeNumber, pos = 1, params = {}) => {
    return apiRequest({
        url: `/barcode/design/${barcodeNumber}/fail?item=${pos}`,
        method: 'PUT',
        data: params,
    })
}

export const updateStatusDesign = (barcodeNumber, numberItem) => {
    return apiRequest({
        url: `barcode/design/${barcodeNumber}/fix?item=${numberItem}`,
        method: 'PUT',
    })
}

export const updateFBAInfo = (barcodeNumber, data) => {
    return apiRequest.put(`/barcode/${barcodeNumber}/fba-info`, data)
}

export const requestUpdateDesign = (barcodeNumber, formData) => {
    return apiRequest({
        url: `/request-update/${barcodeNumber}/design`,
        method: 'POST',
        data: formData,
    })
}

export const importTracking = (file) => {
    return apiRequest({
        url: `/import-tracking/upload-csv`,
        method: 'POST',
        data: file,
    })
}

export const getListBrands = (payload) => {
    return apiRequest({
        url: `/get-list-brand`,
        method: 'POST',
        data: payload,
    })
}

export const markErrors = (id, payload) => {
    return apiRequest({
        url: `/barcode/${id}/item-error-histories`,
        method: 'POST',
        data: payload,
    })
}

export const forecastShipBatchStatistics = async (params) => {
    return apiRequest({
        url: `/report/forecast-ship-batch`,
        method: 'GET'
    })
}

export const forecastShipBatchStatisticsCSV = async (params) => {
    const {
        shipping_carrier,
        col
    } = {...params}

    return apiRequest({
        url: `/report/forecast-ship-batch/csv?shipping_carrier=${shipping_carrier}&col=${col}`,
        method: 'GET'
    }).then(res=>res.data)
}

export const countPendingRegenerateLabel = async () => {
    return apiRequest({
        url: `/alert/pending-regenerate-label/count`,
        method: 'GET'
    })
}

export default {
    generateLabel,
    updateBarcode,
    updateBarcodeReturnAddress,
    createListBarcode,
    importListBarcode,
    getListBarcode,
    getListBarcodeV4,
    getListBarcodeV41,
    deleteBarcode,
    updateBarcodeProduct,
    getBarcodeByNumber,
    getStatistics,
    getStatisticsV2,
    getStatisticsV3,
    getFilters,
    getDesign3D,
    generateLabel3D,
    getParcel,
    createParcel,
    generateParcelLabel,
    resyncDesign,
    exportCSV,
    exportShipping,
    getExportOrdersCSV,
    getExportOrdersCSVv4,
    getBarcodeByArrayNumber,
    markWrongDesign,
    updateStatusDesign,
    updateFBAInfo,
    getExportOrdersRoyalMail,
    getExportOrdersSingaporePost,
    markLabelled,
    getExportSku,
    getExportSkuV3,
    requestUpdateDesign,
    getListBrands,
    exportProductionTimeStatistics,
}
